/** True for /signage and /signageteammember portals (not agent, realtor, etc.). */
export function isSignagePortalRoute(pathname?: string, baseRoute?: string): boolean {
  const p = String(pathname ?? (typeof window !== "undefined" ? window.location.pathname : "")).trim();
  const b = String(baseRoute ?? "").trim();
  if (p.startsWith("/signage") || b.startsWith("/signage")) return true;
  return false;
}
